import React from 'react';
import FormPage from '../../components/FormPage/FormPage';

const Descadastro: React.FC = () => (
  <FormPage
    seoTitle="Cancelar inscrição | 77Gestão"
    seoDescription="Cancele o recebimento dos nossos e-mails."
    canonical="/descadastro"
    noindex
    eyebrow="Descadastro"
    heading="Não quer mais receber nossos e-mails?"
    intro="Informe seu e-mail abaixo e removemos você da nossa lista. Sem ressentimentos."
    fields={[
      { name: 'email', label: 'Seu e-mail', type: 'email', required: true, placeholder: 'voce@empresa.com.br' },
    ]}
    subject="Descadastro — lista 77gestão"
    submitLabel="Confirmar descadastro"
    successTitle="Pronto!"
    successText="Recebemos seu pedido e vamos remover seu e-mail da lista. Você não receberá mais nossos disparos."
  />
);

export default Descadastro;
